import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { userService, TermsDocument } from '../../services/userService';

const TermsPage: React.FC = () => {
  const [terms, setTerms] = useState<TermsDocument | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    userService.getActiveTerms().then((t) => {
      setTerms(t);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      ) : terms ? (
        <>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            {terms.title}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 4, display: 'block' }}>
            Version {terms.version} — Last updated {new Date(terms.updated_at).toLocaleDateString()}
          </Typography>
          <Typography
            component="div"
            sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.8, fontSize: '0.95rem' }}
          >
            {terms.body}
          </Typography>
        </>
      ) : (
        <Typography color="text.secondary">No terms and conditions available.</Typography>
      )}
    </Container>
  );
};

export default TermsPage;
